import moment from "moment";

const UNCATEGORIZED = "Uncategorized";

export const RESULT_SUMMARY_GROUP_BY = {
  NONE: "none",
  SUB_CATEGORY: "subCategory",
  USER: "user",
  STATUS: "testResult",
};

export const RESULT_SUMMARY_GROUP_OPTIONS = [
  { value: RESULT_SUMMARY_GROUP_BY.NONE, label: "None" },
  { value: RESULT_SUMMARY_GROUP_BY.SUB_CATEGORY, label: "Sub Category" },
  { value: RESULT_SUMMARY_GROUP_BY.USER, label: "User" },
  { value: RESULT_SUMMARY_GROUP_BY.STATUS, label: "Status" },
];

export function isResultSummaryGrouped(groupBy) {
  return Boolean(groupBy && groupBy !== RESULT_SUMMARY_GROUP_BY.NONE);
}

function formatGroupLabel(row, groupBy) {
  if (groupBy === RESULT_SUMMARY_GROUP_BY.STATUS) {
    if (row.testResult === "Pass") return "Passed";
    if (row.testResult === "Fail") return "Failed";
    return (row.testResult || "").trim() || UNCATEGORIZED;
  }

  const field =
    groupBy === RESULT_SUMMARY_GROUP_BY.USER ? "user" : "subCategory";
  return (row[field] || "").trim() || UNCATEGORIZED;
}

function sortChildren(rows) {
  return [...rows].sort(
    (a, b) =>
      moment(b.runStart, "DD-MM-YYYY HH:mm:ss").valueOf() -
      moment(a.runStart, "DD-MM-YYYY HH:mm:ss").valueOf(),
  );
}

/**
 * Build Ant Design tree rows grouped by subCategory, user, or testResult (status).
 */
export function sortResultSummaryRows(rows) {
  return sortChildren(rows || []);
}

export function groupResultSummary(rows, groupBy) {
  if (!isResultSummaryGrouped(groupBy) || !rows?.length) return [];

  const buckets = rows.reduce((acc, row) => {
    const label = formatGroupLabel(row, groupBy);
    if (!acc[label]) acc[label] = [];
    acc[label].push(row);
    return acc;
  }, {});

  const sortLabels = (a, b) => {
    if (groupBy === RESULT_SUMMARY_GROUP_BY.STATUS) {
      const order = { Failed: 0, Passed: 1, [UNCATEGORIZED]: 2 };
      return (order[a] ?? 3) - (order[b] ?? 3);
    }
    return a.localeCompare(b);
  };

  return Object.keys(buckets)
    .sort(sortLabels)
    .map((groupLabel) => ({
      key: `group-${groupBy}-${groupLabel}`,
      isGroupHeader: true,
      groupLabel,
      groupBy,
      children: sortChildren(buckets[groupLabel]),
    }));
}

/** @deprecated Use groupResultSummary(rows, 'subCategory') */
export function groupResultSummaryBySubCategory(rows) {
  return groupResultSummary(rows, RESULT_SUMMARY_GROUP_BY.SUB_CATEGORY);
}
